export const THEME_KEY = 'theme';

export const ActionTypes = {
    SET_THEME: 'actions/theme/set_theme',
};
